module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-software-library-34ce3bbb72b6da732c43a2f094abcd96.png";